import { Journal } from "../types";
import { CommonApi, CommonApiMethod } from ".";

const route = "journal";
const journal: CommonApiMethod = new CommonApi<Journal>(route, "Журнал");

export default journal;
